import { render, staticRenderFns } from "./CreateEdit.vue?vue&type=template&id=4f1e2a60&scoped=true"
import script from "./CreateEdit.vue?vue&type=script&lang=js"
export * from "./CreateEdit.vue?vue&type=script&lang=js"
import style0 from "./CreateEdit.vue?vue&type=style&index=0&id=4f1e2a60&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1e2a60",
  null
  
)

export default component.exports